import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initOffice } from '@saip/office'
import '@saip/ui/styles.css'
import { Root } from './Root'

async function bootstrap() {
  const { host, adapter } = await initOffice()

  const container = document.getElementById('root')
  if (!container) throw new Error('#root not found')

  // Everything else — backend wiring included — depends on the stored LiteLLM
  // connection, so it is decided inside <Root/>.
  createRoot(container).render(
    <StrictMode>
      <Root host={host} adapter={adapter} />
    </StrictMode>,
  )
}

void bootstrap()
